module.exports = __webpack_public_path__ + "static/media/23-beals-brush_10_10_2020.eb209da8.jpg";